import { render, staticRenderFns } from "./ProfileCard.vue?vue&type=template&id=40a7d992&scoped=true"
import script from "./ProfileCard.vue?vue&type=script&lang=js"
export * from "./ProfileCard.vue?vue&type=script&lang=js"
import style0 from "./ProfileCard.vue?vue&type=style&index=0&id=40a7d992&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a7d992",
  null
  
)

export default component.exports